import { getProfiles } from "@lib/auth/jwt";
import useContent from "@lib/use_content";
import classNames from "classnames";
import React, { useState } from "react";
import ReservationList from "./ReservationList";

interface ReservationProps {
  onPageChange: (page: string) => void;
}

interface Tab {
  name: string;
  value: be.ProfileReservationDateRange;
}

export default function Reservations({ onPageChange }: ReservationProps) {
  const { data } = useContent([
    "beProfileResOpenTab",
    "beProfileResPastTab",
    "beProfileResUpcomingTab",
  ]);
  const [dateRange, setDateRange] = useState<be.ProfileReservationDateRange>("future");

  const tabs: Tab[] = [
    { name: data?.content.beProfileResUpcomingTab || "", value: "future" },
    { name: data?.content.beProfileResPastTab || "", value: "past" },
    { name: data?.content.beProfileResOpenTab || "", value: "open" },
  ];

  function onChange(e: React.ChangeEvent<HTMLSelectElement>) {
    let newDateRange: be.ProfileReservationDateRange = "future",
      value = e.target.value.toLowerCase();

    if (value == "open" || value == "future" || value == "past") newDateRange = value;
    setDateRange(newDateRange);
  }

  const profileId = getProfiles().user;
  if (!profileId) return null;

  return (
    <div className="pt-8">
      <div className="sm:hidden">
        <select
          id="tabs"
          name="tabs"
          className="block w-full rounded-md border-gray-300 focus:border-[--primary-color] focus:ring-[--primary-color] mb-8"
          defaultValue={tabs.find((tab) => tab.value == dateRange)?.value || "future"}
          onChange={onChange}
        >
          {tabs.map((tab) => (
            <option key={tab.value}>{tab.name}</option>
          ))}
        </select>
      </div>
      <div className="hidden sm:flex justify-center">
        <nav className="flex space-x-4" aria-label="Tabs">
          {tabs.map((tab) => (
            <a
              key={tab.value}
              onClick={() => setDateRange(tab.value)}
              className={classNames(
                tab.value == dateRange
                  ? "bg-[--primary-color] text-[--primary-text]"
                  : "text-gray-500 hover:text-gray-700",
                "rounded-md px-3 py-2 text-sm font-medium cursor-pointer",
              )}
            >
              {tab.name}
            </a>
          ))}
        </nav>
      </div>
      <ReservationList
        key={dateRange}
        dateRange={dateRange}
        onPageChange={onPageChange}
        profileId={profileId}
      />
    </div>
  );
}
